import 'babel-polyfill';

import objectFitImages from 'object-fit-images';
import React, { Component } from 'react';
import withRouter from 'react-router-dom/withRouter';
import Header from '../components/global/Header';
import Intro from '../components/global/intro';
import Exhibition from '../components/exhibition';
import PixiComponent from '../components/pixi/PixiComponent';
import '../style/main.scss';

const mobileMenuBreakpoint = 1200;

class Frame extends Component {
  state = {
    isLightBG: true,
    logoColor: 'black',
    mainNavColor: 'black',
    themeColor: 'red',
    headerHasGradient: false,
    dropdownNavColor: 'white',
    headerIsSticky: true,
    headerIsStatic: false,
    menuCollapsedPage: this.routeShouldCollapseHeader(
      this.props.location.pathname
    ),
    targetEra: { index: -1, era: {}, skipTo: () => {} },
    menuToggledOpen: false,
    isMobileMenuOpen: false,
    headerIsTransparent: true,
    screenOrientation: '',
    showIntro: true,
    chapterToExhibition: false,
    exhibitionRouteStatus: this.isExhibition(this.props.location.pathname)
      ? 'entering'
      : 'exiting',
  };
  routeShouldCollapseHeader(pathname) {
    return (
      pathname.indexOf('exhibition') !== -1 ||
      pathname.indexOf('timeline') !== -1
    );
  }

  // TODO: Rename this to be more generic for resize events
  setScreenOrientation = () => {
    if (typeof window !== 'undefined') {
      if (window.innerHeight < window.innerWidth) {
        this.setState({
          screenOrientation: 'landscape',
        });
      } else {
        this.setState({
          screenOrientation: 'portrait',
        });
      }
      if (window.innerWidth > mobileMenuBreakpoint) {
        this.setState({
          isMobileMenuOpen: false,
        });
      }
    }
  };

  setHeaderStyleFromSection = (sectionData, reset = false) => {
    let logoColor, mainNavColor, headerHasGradient, dropdownNavColor;
    if (reset) {
      mainNavColor = 'black';
      logoColor = 'black';
      headerHasGradient = false;
      dropdownNavColor = 'black';
    } else {
      switch (sectionData.section_type) {
        case 'split_image_and_text':
          const leftSplit =
            sectionData.image_alignment === 'left' ? true : false;
          const splitMainNavColor = leftSplit ? 'black' : 'white';
          const splitLogoColor = leftSplit ? 'white' : 'black';
          const splitDropdownNavColor = leftSplit ? 'black' : 'white';
          mainNavColor = window.innerWidth < 768 ? 'white' : splitMainNavColor;
          logoColor = window.innerWidth < 768 ? 'white' : splitLogoColor;
          headerHasGradient = false;
          dropdownNavColor =
            window.innerWidth < 768 ? 'white' : splitDropdownNavColor;
          break;

        case 'full_width_image_with_text':
        case 'press_and_hold':
        case 'quote':
        default:
          mainNavColor = 'white';
          logoColor = 'white';
          headerHasGradient = true;
          dropdownNavColor = 'white';
          break;
      }
    }

    this.setMainMenuColor(mainNavColor);
    this.setLogoColor(logoColor);
    this.setHeaderGradient(headerHasGradient);
  };
  setLogoColor = value => {
    this.setState({
      logoColor: value,
    });
  };

  setMainMenuColor = value => {
    this.setState({
      mainNavColor: value,
    });
  };

  setHeaderGradient = value => {
    this.setState({
      headerHasGradient: value,
    });
  };

  setHeaderTransparent = value => {
    this.setState({
      headerIsTransparent: value,
    });
  };

  setHeaderStatic = value => {
    this.setState({
      headerIsStatic: value,
    });
  };

  toggleDesktopMenu = value => {
    if (value) {
      this.setState({
        menuToggledOpen: value,
      });
    } else {
      this.setState(state => ({
        menuToggledOpen: !state.menuToggledOpen,
      }));
    }
  };

  handleMobileMenu = () => {
    this.setState(state => ({
      isMobileMenuOpen: !state.isMobileMenuOpen,
    }));
  };

  setHeaderSticky = value => {
    this.setState({
      headerIsSticky: value,
    });
  };

  setThemeColor = color => {
    this.setState({
      themeColor: color,
    });
  };

  getThemeClass = color => {
    switch (color) {
      case 'blue':
        return `main-theme--blue`;
      case 'yellow':
        return `main-theme--yellow`;
      case 'green':
        return `main-theme--green`;
      default:
        return `main-theme--red`;
    }
  };

  resetDisplaySettings = () => {
    this.setMainMenuColor('black');
    this.setLogoColor('black');
    this.setHeaderGradient(false);
    this.setThemeColor('red');
  };

  componentWillMount() {
    // for dev purposes, can put #skip on any url not to show intro
    if (
      this.props.location.search.indexOf('skip=true') !== -1 ||
      this.props.location.pathname.indexOf('/educator-resources/') !== -1
    ) {
      // if (this.props.location.search.indexOf('skip=true') !== -1) {
      this.setState({ showIntro: false });
    }

    this.setScreenOrientation();

    if (typeof document !== 'undefined') {
      this.body = document.querySelector('body');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.themeColor !== this.state.themeColor) {
      this.body.classList.remove(this.getThemeClass(prevState.themeColor));
      this.body.classList.add(this.getThemeClass(this.state.themeColor));
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // close mobile menu on route change
      this.setState({ isMobileMenuOpen: false });
      this.checkDisplayHeader();
    }
    // object-fit polyfill
    objectFitImages();
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.setScreenOrientation);
    }
    this.setScreenOrientation();
    this.body.classList.add(this.getThemeClass(this.state.themeColor));
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.setScreenOrientation);
    }
  }
  checkDisplayHeader() {
    this.setState({
      menuCollapsedPage: this.routeShouldCollapseHeader(
        this.props.location.pathname
      ),
      menuToggledOpen: false,
    });
  }
  introComplete = () => {
    this.setState({ showIntro: false });
  };
  beforeExitChapter = () => {
    if (this.hideSliderText) {
      this.hideSliderText();
    }
  };
  onExitChapter = index => {
    if (this.triggerNextSlide) {
      this.triggerNextSlide(index);
    }
    this.pixiInFrontOfExhibition();
  };
  registerNextSlide = func => {
    this.triggerNextSlide = func;
  };
  registerNextSlideWithPixi = func => {
    this.triggerNextSlideWithPixi = func;
  };
  registerHideSliderText = func => {
    this.hideSliderText = func;
  };
  registerChapterExit = func => {
    this.chapterExit = func;
  };
  pixiInFrontOfExhibition = () => {
    this.setState({ chapterToExhibition: true });
  };
  pixiBehindExhibition = () => {
    this.setState({ chapterToExhibition: false });
  };
  isExhibition(path) {
    return path === '/exhibition' || path === '/exhibition/';
  }
  handleChapterNav = index => {
    if (this.isExhibition(this.props.location.pathname)) {
      //if on exhibition page, just move slider
      this.triggerNextSlideWithPixi(index);
    } else {
      this.chapterExit(index);
    }
  };
  updateExhibitionRoute = status => {
    this.setState({ exhibitionRouteStatus: status });
  };

  registerEraSkip = eraObj => this.setState({ targetEra: eraObj });

  render() {
    return (
      <main className={`container`}>
        <Header
          menuCollapsedPage={this.state.menuCollapsedPage}
          menuToggledOpen={this.state.menuToggledOpen}
          headerHasGradient={this.state.headerHasGradient}
          headerIsTransparent={this.state.headerIsTransparent}
          headerIsSticky={this.state.headerIsSticky}
          headerIsStatic={this.state.headerIsStatic}
          mainNavColor={this.state.mainNavColor}
          logoColor={this.state.logoColor}
          dropdownNavColor={this.state.dropdownNavColor}
          isMobileMenuOpen={this.state.isMobileMenuOpen}
          location={this.props.location}
          exhibitionData={this.props.data.exhibitionOrder}
          chapterData={this.props.data.exhibitionChapters}
          timelineData={this.props.data.timeline}
          handleMobileMenu={this.handleMobileMenu}
          toggleDesktopMenu={this.toggleDesktopMenu}
          settingsContent={this.props.data.settings.edges[0].node}
          introIsShowing={this.state.showIntro}
          handleChapterNav={this.handleChapterNav}
          registerEraSkip={this.registerEraSkip}
        />
        {this.state.showIntro && (
          <Intro
            onIntroComplete={this.introComplete}
            location={this.props.location}
            image={
              this.props.data.homeCover.edges[0].node.home_image.sizes.large
            }
            text={this.props.data.settings.edges[0].node.loading_text}
          />
        )}
        <Exhibition
          location={this.props.location}
          exhibitionData={this.props.data.exhibitionOrder}
          chapterData={this.props.data.exhibitionChapters}
          registerNextSlideWithPixi={this.registerNextSlideWithPixi}
          layoutFunctions={{
            setMainMenuColor: this.setMainMenuColor,
            setHeaderGradient: this.setHeaderGradient,
            setThemeColor: this.setThemeColor,
            setLogoColor: this.setLogoColor,
            setHeaderStyleFromSection: this.setHeaderStyleFromSection,
            setMenuCollapsed: this.toggleDesktopMenu,
          }}
          chapterToExhibition={this.state.chapterToExhibition}
          registerNextSlide={this.registerNextSlide}
          introIsShowing={this.state.showIntro}
          registerHideSliderText={this.registerHideSliderText}
          exhibitionRouteStatus={this.state.exhibitionRouteStatus}
        />

        <PixiComponent chapterToExhibition={this.state.chapterToExhibition} />

        {this.props.children({
          ...this.props,
          layout: false,
          screenOrientation: this.state.screenOrientation,
          setLogoColor: this.setLogoColor,
          setMainMenuColor: this.setMainMenuColor,
          setHeaderGradient: this.setHeaderGradient,
          setThemeColor: this.setThemeColor,
          setHeaderTransparent: this.setHeaderTransparent,
          setHeaderSticky: this.setHeaderSticky,
          setHeaderStatic: this.setHeaderStatic,
          resetDisplaySettings: this.resetDisplaySettings,
          setHeaderStyleFromSection: this.setHeaderStyleFromSection,
          dropdownNavColor: this.state.dropdownNavColor,
          onExitChapter: this.onExitChapter,
          beforeExitChapter: this.beforeExitChapter,
          pixiBehindExhibition: this.pixiBehindExhibition,
          settingsContent: this.props.data.settings.edges[0].node,
          introIsShowing: this.state.showIntro,
          registerChapterExit: this.registerChapterExit,
          updateExhibitionRoute: this.updateExhibitionRoute,
          targetEra: this.state.targetEra,
        })}
      </main>
    );
  }
}

export default withRouter(Frame);

export const query = graphql`
  query GlobalQuery {
    site {
      siteMetadata {
        title
      }
    }
    settings: allLiveJson {
      edges {
        node {
          hours {
            days
            open_time
            close_time
          }
          credits_pdf_file {
            url
          }
          credits_pdf_link_text
          weekend_hours {
            title
            url
            target
          }
          menu {
            title
            path
          }
          loading_text
          social {
            instagram
            facebook
            youtube
            twitter
            donate
          }
        }
      }
    }
    timeline: allDataJson(filter: { post_type: { eq: "timeline" } }) {
      edges {
        node {
          path
          eras {
            add_link_to_about_page
            starting_year
            ending_year
          }
        }
      }
    }
    homeCover: allDataJson(filter: { post_type: { regex: "/exhibition/" } }) {
      edges {
        node {
          home_image {
            url
            alt
            sizes {
              large
            }
          }
        }
      }
    }
    exhibitionOrder: allDataJson(filter: { post_type: { eq: "exhibition" } }) {
      edges {
        node {
          path
          title
          chapters
        }
      }
    }
    exhibitionChapters: allDataJson(filter: { post_type: { eq: "chapter" } }) {
      edges {
        node {
          path
          id
          subtitle
          title
          color_theme
          exhibition_sections {
            section_type
            image_alignment
            image {
              url
              alt
              sizes {
                large
              }
            }
            images {
              sizes {
                #medium
                large
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js